import { IonContent, IonPage, IonNavLink, IonButton, useIonAlert } from '@ionic/react'
import { useContext, useEffect, useRef, useState } from 'react'
import { DataLoadingModal, ResProductDetail, ResultBuyProduct, ResultTradeProduct } from '../../../../common'
import { StoresContext } from '../../../../provider/StoreProvider'
import { SaleDoneModal } from './SaleDoneModal'
import { TradeResultDoneModal } from './TradeResultDoneModal'
import { TradeResultYetModal } from './TradeResultYetModal'

type Props = {
  type: 'SALE' | 'TRADE'
  saleData?: { saleId: number; count: number; walletId?: number; isReceipt: boolean; receiptPhoneNumber: number }
  tradeData?: { productData: ResProductDetail; cost: number; count: number; orderType: 'BUY' | 'SELL' }
  onDismiss: () => void
}

export const LoadingModal: React.FC<Props> = ({ type, saleData, tradeData, onDismiss }) => {
  const { marketStore } = useContext(StoresContext)
  const [saleResult, setSaleResult] = useState<ResultBuyProduct | null>(null)
  const [tradeResult, setTradeResult] = useState<ResultTradeProduct | null>(null)
  const [presentAlert] = useIonAlert()
  const nextBtn = useRef<HTMLIonButtonElement>(null)
  const backBtn = useRef<HTMLIonButtonElement>(null)

  useEffect(() => {
    type === 'SALE' ? doSale() : doTrade()
  }, [])

  const doFail = () => {
    if (backBtn.current == null) {
      return
    }
    presentAlert({
      mode: 'md',
      header: '처리에 오류가 발생했습니다',
      message: '잠시 후 다시 시도해주세요',
      cssClass: 'custom-alert-alert ',
      buttons: [
        {
          text: '확인',
          cssClass: 'alert-button-single',
        },
      ],
      onDidDismiss: () => {
        backBtn.current?.click()
      },
    })
  }

  const doSale = async (): Promise<void> => {
    if (saleData == null) {
      return
    }
    let result
    if (saleData.isReceipt) {
      result = await marketStore.buyProduct(saleData.saleId, {
        walletId: saleData.walletId,
        count: saleData.count,
        extraData: {
          receiptPhoneNumber: saleData.receiptPhoneNumber,
        },
      })
    } else {
      result = await marketStore.buyProduct(saleData.saleId, {
        walletId: saleData.walletId,
        count: saleData.count,
      })
    }
    if (result == null) {
      doFail()
      return
    }
    setSaleResult(result)
    await new Promise((f) => setTimeout(f, 500))
    if (nextBtn.current != null) {
      nextBtn.current.click()
    }
  }

  const doTrade = async (): Promise<void> => {
    if (tradeData == null) {
      return
    }
    const result = await marketStore.tradeProduct(tradeData.productData.id, {
      cost: tradeData.cost,
      count: tradeData.count,
      orderType: tradeData.orderType,
    })
    if (result == null) {
      doFail()
      return
    }
    setTradeResult(result)
    await new Promise((f) => setTimeout(f, 500))
    if (nextBtn.current != null) {
      nextBtn.current.click()
    }
  }

  return (
    <IonPage>
      <IonContent>
        <DataLoadingModal
          message={`${
            type === 'SALE' ? '구매' : tradeData?.orderType === 'SELL' ? '매도 거래' : '매수 거래'
          } 처리 중 입니다`}
        />
        {(saleResult != null || tradeResult != null) && (
          <IonNavLink
            routerDirection="forward"
            component={() =>
              saleResult != null ? (
                <SaleDoneModal resultBuyProduct={saleResult} onDismiss={onDismiss} />
              ) : tradeResult != null && tradeData != null ? (
                tradeResult.purchases.length > 0 ? (
                  <TradeResultDoneModal
                    tradeResult={tradeResult}
                    productData={tradeData.productData}
                    onDismiss={onDismiss}
                  />
                ) : (
                  <TradeResultYetModal
                    tradeResult={tradeResult}
                    productData={tradeData.productData}
                    onDismiss={onDismiss}
                  />
                )
              ) : (
                <></>
              )
            }
          >
            <IonButton fill="clear" ref={nextBtn} />
          </IonNavLink>
        )}
        <IonNavLink routerDirection="back">
          <IonButton fill="clear" ref={backBtn} />
        </IonNavLink>
      </IonContent>
    </IonPage>
  )
}
